<mat-dialog-content class="!p-1">
	<mat-calendar
		(selectedChange)="this.close($event)"
		[maxDate]="this.maxDate$ | async"
		[minDate]="this.minDate$ | async"
		[selected]="this.selectedDate$ | async"
		[startAt]="this.selectedDate$ | async"
		#calview
		class="calendar-item"
		color="primary"
	></mat-calendar>
</mat-dialog-content>
